const { createApp, ref, reactive, onBeforeMount, toRefs, computed, onMounted, onBeforeUnmount } =
  Vue;

import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

function money(value) {
  if (!value) return "-";
  const formatter = new Intl.NumberFormat("ja-JP", {});
  let price = parseInt(value);
  return formatter.format(price);
}

createApp({
  delimiters: ["${", "}"],
  setup() {
    const state = reactive({
      crowdfund: crowdfunding,
      product: product,
      progress: computed(computeProgress),
      days: computed(daysLeft),
      mainImageLoading: false,
      variant: computed(selectedVariant),
      progressAdd: computed(computeProdressAdd),
      expiry: null,
      isExpired: computed(computeExpired),
      countdown: computed(countDown),
      pricing: null,
      quantity: 1,
      showModal: false,
      modalContent: "",
    });

    function supporters(people) {
      if (!people) return 0;
      return Math.round(people);
    }

    function selectedVariant() {
      let selected = state.product.variants.filter((v) => v.selected);

      if (selected) return selected;
      return state.product.variants[0];
    }

    function countDown() {
      if (!state.expiry) return "";
      //console.log(state.expiry);

      let now = new Date();
      return now.getDate();
    }

    function changeMain(e, image) {
      if (state.product.featured_image == image) return;
      state.mainImageLoading = false;
      state.product.featured_image = image;
    }

    function imageLoading(e) {
      state.mainImageLoading = true;
    }

    function handlePriceChange(e) {
      console.log(e);
    }

    function imageError(e) {
      console.log("error");
    }

    function computeProgress() {
      if (!state.crowdfund.current) return 0;
      let percentage = (state.crowdfund.current / state.crowdfund.goal) * 100;
      if (percentage > 100) return 100;

      return Math.round(percentage);
    }

    function computeProdressAdd() {
      let variant = state.product.variants.find((v) => v.id == state.variantID);
      if (!variant) return;

      let variantPrice = variant.price / 100;
      let current = parseInt(state.crowdfund.current);
      let goal = parseInt(state.crowdfund.goal);

      let percentage = ((current + variantPrice) / goal) * 100;

      if (percentage > 100) return 100;
      return Math.round(percentage);
    }

    function date() {
      let date = new Date(state.crowdfund.expiry);
      return date.getDate();
    }

    function expiry(d) {
      let expiryDate = new Date(state.crowdfund.expiry);
      let year = expiryDate.getFullYear();
      let month = expiryDate.getMonth() + 1;
      let day = expiryDate.getDate();
      let hours = expiryDate.getHours();
      let minutes = expiryDate.getMinutes();
      let seconds = expiryDate.getSeconds();
      //console.log(expiryDate);
      return `${year}年${month}月${day}日`;
    }

    function computeExpired() {
      let expiryTimestamp = new Date(state.crowdfund.expiry).getTime();
      let nowTimestamp = Date.now();
      return nowTimestamp >= expiryTimestamp;
    }

    function outOfStock(v) {
      if (v.inventory_policy == "deny" && v.inventory_quantity <= 0)
        return true;
      return false;
    }

    function prependZero(num) {
      let numStr = num.toString();
      if (numStr.length === 1) {
        return "0" + numStr;
      } else {
        return numStr;
      }
    }

    function getSupporter(supporter) {
      if (!supporter) return "-";
      return Math.round(supporter);
    }

    function daysLeft() {
      let currentDate = new Date();
      let expiryDate = new Date(state.crowdfund.expiry);
      let timeDifference = expiryDate.getTime() - currentDate.getTime();
      let days = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      if (days <= 0) return "00";

      return prependZero(days);
    }

    const toggleModalVisibility = () => {
      state.showModal = !state.showModal;
      if (state.showModal) {
        // Disable scrolling
        document.body.style.overflow = "hidden";

        const productForm = document.querySelector(".form__wrapper form");
        const optionModalContent = document.querySelector(".modal__content");
        optionModalContent.appendChild(productForm);
      }else{
        document.body.style.overflow = "auto";
        
        const formWrapper = document.querySelector(".form__wrapper");
        const productForm = document.querySelector(".modal__content form");
        formWrapper.appendChild(productForm);
      }
      console.log(`Modal visibility: ${state.showModal}`);
    };

    onMounted(() => {
      const form = document.querySelector("form");
      form.addEventListener("change", (e) => {
        console.log(e);
      });

      /******************************
        * Floating button & Modal
        * ******************************/
      const optionGroup = document.querySelector(".option__group");
      const floatingButton = document.querySelector(".floating__button");
      const handleScroll = () => {
        if (!optionGroup || !floatingButton) return;

        const optionGroupRect = optionGroup.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (optionGroupRect.top <= windowHeight) {
          floatingButton.classList.remove("is-show");
        } else {
          floatingButton.classList.add("is-show");
        }
      };
      window.addEventListener("scroll", handleScroll);

      // PCサイズ（640px）かつモーダルが表示されている場合、モーダルを閉じる
      const mediaQuery = window.matchMedia("(min-width: 640px)");
      const handleMediaQuery = (e) => {
        if (e.matches && state.showModal) {
          toggleModalVisibility();
        }
      };
      mediaQuery.addEventListener("change", handleMediaQuery);

      onBeforeUnmount(() => {
        window.removeEventListener("scroll", handleScroll);
      });

    });

    onBeforeMount(() => {});

    return {
      ...toRefs(state),
      toggleModalVisibility,
      imageLoading,
      changeMain,
      imageError,
      handlePriceChange,
      outOfStock,

      //FILTERS
      money,
      date,
      expiry,
      supporters,
      getSupporter,
    };
  },
}).mount("main");
